import type { Participant } from "../types";

export function mentionTrigger(text: string, caret: number) {
  const match = text.slice(0, caret).match(/(?:^|[\s(])@([^\s@]*)$/u);
  return match
    ? { start: caret - match[1].length - 1, end: caret, query: match[1] }
    : null;
}

/** Typed display text alone cannot address a participant; selection supplies IDs. */
export function retainedMentionIds(
  text: string,
  ids: string[],
  participants: Participant[],
) {
  return [...new Set(ids)].filter((id) => {
    const participant = participants.find((item) => item.memberId === id);
    return participant && text.includes(`@${participant.name}`);
  });
}
